import en from './I10n/en.json';

export default {
  en: { data: en, name: 'English' },
};
